"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIDEO_TYPE = exports.SCROLL_DURATION = exports.COPY_STATUS = void 0;
var SCROLL_DURATION = 500;
exports.SCROLL_DURATION = SCROLL_DURATION;
var VIDEO_TYPE = /*#__PURE__*/function (VIDEO_TYPE) {
  VIDEO_TYPE["youtube"] = "youtube";
  VIDEO_TYPE["vimeo"] = "vimeo";
  return VIDEO_TYPE;
}(VIDEO_TYPE || {});
exports.VIDEO_TYPE = VIDEO_TYPE;
var COPY_STATUS = /*#__PURE__*/function (COPY_STATUS) {
  COPY_STATUS["success"] = "success";
  COPY_STATUS["failure"] = "failure";
  return COPY_STATUS;
}(COPY_STATUS || {});
exports.COPY_STATUS = COPY_STATUS;